<template>
  <div>
    <el-header class="header" v-show='showTemplateList && $route.path !== "/chat"'>
      <h3 class="title">
        <div class="block">
          <span>工单模板列表</span>
        </div>
      </h3>
    </el-header>
   <el-container v-show='showTemplateList'>
      <el-row class="work-bfb" style="width:100%">
        <div class="table-tool">
          <el-form inline ref="form" label-width="80px" v-if="$store.state.order.orderPermission.createTemplate && $route.path !== '/chat'">
            <el-form-item style="margin-top:0;margin-right:0;float:right;padding-right:0">
              <el-button size="small" type="primary" @click="createTemplate">创建工单模板</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="templates" class="log-table table-main" :header-cell-style="{background:'#f5f5f5',borderRight: '1px solid #fff',textAlign:'center'}">
          <el-table-column align="center" prop="templateName" label="模板名称"></el-table-column>
          <el-table-column align="center" prop="type" label="模板类型" :formatter='formatType'></el-table-column>
          <el-table-column align="center" prop="status" label="状态" :formatter='formatStatus'></el-table-column>
          <el-table-column align="center" prop="times" label="引用次数" ></el-table-column>
          <el-table-column align="center" prop="creator" label="创建人"></el-table-column>
          <el-table-column align="center" prop="createTime" label="创建时间" width="200" :formatter='formatTime'></el-table-column>
          <el-table-column align="center" prop="" label="操作" fixed="right" width="100" height="100%">
            <template v-slot="scope">
              <el-tooltip class="item" effect="light" content="查看" placement="bottom">
                <el-button  @click="viewTemplate(scope)" type="text">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#iconxiangqing" />
                  </svg>
                </el-button>
              </el-tooltip>
              <el-tooltip v-if="scope.row.status > -1" class="item" effect="light" content="创建工单" placement="bottom">
                <el-button @click="createOrder(scope)" type="text">
                  <svg class="icon icon-bianji" aria-hidden="true">
                    <use xlink:href="#iconchuangjiangongdan" />
                  </svg>
                </el-button>
              </el-tooltip>
              <el-tooltip v-if="$store.state.order.orderPermission.deleteTemplate && scope.row.times == 0" class="item" effect="light" content="删除" placement="bottom">
                <el-button @click="deleteTemplate(scope)" type="text">
                  <svg class="icon icon-delete" aria-hidden="true">
                    <use xlink:href="#icontable-delete"/>
                  </svg>
                </el-button>
              </el-tooltip>
              <!-- <el-button style="padding: 0%;" @click="editTemplate(scope)" type="text" size="small" v-if="$store.state.order.orderPermission.updateTemplate && scope.row.times == 0">编辑</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="work-mt20 work-mb20"
          @current-change="handleCurrentChange"
          :current-page="form.page"
          :page-size="form.limit"
          layout="total, prev, pager, next, jumper"
          :total="form.total"
        ></el-pagination>
      </el-row>
    </el-container>
      <Order v-if='showOrderPage' :pageName='orderPageName' v-on:goBack='hidePage'/>
      <Template v-if='showTemplatePage' :pageName='templatePageName' v-on:goBack='hidePage' :v-if='showTemplatePage'/>
  </div>
</template>

<script>
import Order from './Order'
import Template from './Template'
export default {
  name: 'TemplateList',
  components: { Order, Template },
  data() {
    return {
      orderPageName: '',
      templatePageName: '',
      creator: this.$store.state.user.userInfo.userName,
      templateType: 0,
      form: {
        page: 1,
        limit: 10,
        total: 0
      },
      templates: [],
      showTemplateList: true,
      showOrderPage: false,
      showTemplatePage: false
    }
  },
  props: [],
  mounted() {
    this.getTemplates('', this.orderType)
  },
  beforeUpdate: function() {
    document.getElementsByClassName('el-table__fixed-right')[0].style.height = '100%'
  },
  methods: {
    createTemplate() {
      this.templatePageName = '创建模板'
      const template = {
        creator: this.$store.state.user.userInfo.userName,
        type: 0,
        fieldGroups: [
          {
            groupName: '',
            displayOrder: 1,
            fields: [
              {
                fieldName: '工单指派',
                fieldId: 'workorder_assignee',
                id: 'workorder_assignee',
                fieldTag: 'workorder_assignee',
                value: '',
                fieldType: 'select_dynamic',
                fieldValues: null,
                displayOrder: 1
              }, {
                fieldName: '',
                fieldId: 'linkSessionsAndCustomer',
                fieldTag: 'linkSessionsAndCustomer',
                value: '',
                fieldType: 'linkSessionsAndCustomer',
                fieldValues: null,
                displayOrder: 2
              }
            ]
          }, {
            groupName: '',
            displayOrder: 2,
            fields: []
          }
        ]
      }

      this.$store.commit('order/saveTemplate', template)
      this.showTemplateList = false
      this.showTemplatePage = true
    },
    viewTemplate(scope) {
      this.templatePageName = '模板详情'
      this.$store.commit('order/saveTemplate', scope.row)
      this.showTemplateList = false
      this.showTemplatePage = true
    },
    editTemplate(scope) {
      this.$store.commit('order/saveTemplate', scope.row)
      this.showTemplateList = false
      this.showTemplatePage = true
    },
    deleteTemplate(scope) {
      this.$confirm('此操作将永久删除该模板, 是否继续?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      }).then(() => {
        const params = {
          templateId: scope.row.id
        }
        const that = this
        this.$http.delete(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/template/delete', { params }).then(function(response) {
          if (response.data.code === 2000) {
            that.$message.success('成功删除！')
            that.getTemplates('', that.orderType)
          } else if (response.data.code === 2001) {
            that.$message.error(response.data.msg)
          }
        }).catch(function(error) {
          console.log(error)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    createOrder(scope) {
      var that = this
      this.orderPageName = '创建工单'
      this.$http.get(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/template/get?templateId=' + scope.row.id).then(res => {
        const order = {
          id: null,
          name: '',
          creator: this.$store.state.user.userInfo.userName,
          status: 0,
          template: res.data.data,
          templateId: scope.row.id,
          templateName: scope.row.templateName,
          customerId: '',
          customer: null,
          sessionIds: '',
          linkedSessions: []
        }
        if (that.$route.path === '/chat') {
          order.customer = that.$store.state.crm.customer
          order.customerIds = [that.$store.state.crm.customer.id]
        }

        that.$store.commit('order/saveOrder', order)

        if (that.$route.path === '/chat') {
          const widgetOrderUtils = that.$store.state.order.widgetOrderUtils
          that.$store.commit('order/saveWidgetOrderUtils', widgetOrderUtils)
          that.$set(widgetOrderUtils, 'showOrderDetail', true)
        }
        that.showOrderPage = true
        that.showTemplateList = false
        that.showTemplatePage = false
      })
    },
    handleCurrentChange(page) {
      this.form.page = page
      this.getTemplates()
    },
    handleSizeChange(size) {
      this.size = size
    },
    getTemplates() {
      var that = this
      const params = {
        page: this.form.page,
        limit: this.form.limit
      }
      if (this.$route.path === '/chat') {
        params.status = 0
      }

      this.$http.get(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/template/list', { params }).then(res => {
        if (res.data.code === 2000) {
          that.templates = res.data.data.list
          that.form.total = res.data.data.total
        }
      })
    },
    formatTime(row, column, cellValue, index) {
      if (this.$route.path === '/chat') {
        var date = new Date(cellValue)
        return (date.getMonth() + 1) + '月' + date.getDate() + '日'
      } else {
        return cellValue
      }
    },
    formatType(row, column, cellValue, index) {
      if (cellValue === 0) {
        return '售前'
      } else if (cellValue === 1) {
        return '售中'
      } else {
        return '售后'
      }
    },
    formatStatus(row, column, cellValue, index) {
      if (cellValue === -1) {
        return <span style="color:#f66f6a">待审核</span>
      } else if (cellValue === 0) {
        return <span style="color:#4abe49">审核通过</span>
      } else {
        return <span style="color:#337eff">使用中</span>
      }
    },
    hidePage(data) {
      this.showOrderPage = false
      this.showTemplatePage = false
      this.showTemplateList = true
      this.getTemplates('', this.orderType)
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === 'customers' || from.path === '/chatlog') {
      next(vm => {
        vm.showTemplateList = false
        vm.showOrderPage = true
      })
    } else {
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-pagination {
  text-align: right;
  margin-top:10px
}

.block{
    display: inline-block;
    position: relative;
}

.block:after{
    content: "";
    position: absolute;
    left: 0;
    bottom: -11px;
    width: 110%;
    height: 1px;
    background-color: #337eff;
}

.header {
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
}
.el-table .cell{
padding-right:0;
}
</style>
<style>
.el-message-box__btns {
    font-size: 18px;
    text-align: center;
}
</style>
